export enum HierarchyActionTypes {
  GET_HIERARCHY_PENDING = '@@hierarchy/GET_HIERARCHY_PENDING',
  GET_HIERARCHY_SUCCESS = '@@hierarchy/GET_HIERARCHY_SUCCESS',
  GET_HIERARCHY_ERROR = '@@hierarchy/GET_HIERARCHY_ERROR'
}
